import { serviceMaker, methods, api } from "@/http/index.js";

export const getTeamData = () =>
  serviceMaker(`/ticketteam`, methods.GET, api.NGB);
export const getTeamUserData = () =>
  serviceMaker(`/ticketmapping`, methods.GET, api.NGB);
export const addTicketCount = (id, data) =>
  serviceMaker(`/ticketmapping/maxticketcount/${id}`, methods.PUT, api.NGB, data);
export const getTeamDataTemplate = () =>
  serviceMaker(`/ticketteam/template`, methods.GET, api.NGB);
export const createTeamData = (data) =>
  serviceMaker(`/ticketteam`, methods.POST, api.NGB, data);
export const createShiftMappingTemplate = (data) =>
  serviceMaker(`/shiftmapping`, methods.POST, api.NGB, data);
export const getTeamUserDataTemplate = () =>
  serviceMaker(`/ticketmapping/template`, methods.GET, api.NGB);
export const getShiftMappingData = (id) =>
  serviceMaker(`/shiftmapping/template`, methods.GET, api.NGB);
export const getShiftMappingId = (id) =>
  serviceMaker(`/ticketmapping/${id}`, methods.GET, api.NGB);
export const createTeamUserData = (data) =>
  serviceMaker(`/ticketmapping`, methods.POST, api.NGB, data);
export const getTeamByID = (id) =>
  serviceMaker(`/ticketteam/${id}`, methods.GET, api.NGB);
export const editTeam = (id, data) =>
  serviceMaker(`/ticketteam/${id}`, methods.PUT, api.NGB, data);
export const getTicketUserByID = (id) =>
  serviceMaker(`/ticketmapping/${id}`, methods.GET, api.NGB);
export const editTicketUser = (id, data) =>
  serviceMaker(`/ticketmapping/${id}`, methods.PUT, api.NGB, data);
export const deleteTeamTicket = (id) =>
  serviceMaker(`/ticketteam/${id}`, methods.DELETE, api.NGB);
export const deleteTicketUser = (id) =>
  serviceMaker(`/ticketmapping/${id}`, methods.DELETE, api.NGB);

export const getUserAvailability = () =>
  serviceMaker(`/useravailability`, methods.GET, api.NGB);
export const getUserAvailabilityByUserId = (userId) =>
  serviceMaker(`/useravailability/user/${userId}`, methods.GET, api.NGB);
export const getUserAvailabilityById = (id) =>
  serviceMaker(`/useravailability/${id}`, methods.GET, api.NGB);
export const getLeaveByUserId = (id) =>
  serviceMaker(`/useravailability/user/${id}`, methods.GET, api.NGB);
export const updateUserAvailability = (id, data) =>
  serviceMaker(`/useravailability/${id}`, methods.PUT, api.NGB, data);
export const deleteUserLeave = (id) =>
  serviceMaker(`/useravailability/cancel/${id}`, methods.PUT, api.NGB);
export const createUserAvailability = (data) =>
  serviceMaker(`/useravailability`, methods.POST, api.NGB, data);
export const getShiftMapping = () =>
  serviceMaker(`/shiftmapping`, methods.GET, api.NGB);
export const getShiftMappingById = (teamId) =>
  serviceMaker(`/shiftmapping?teamId=${teamId}`, methods.GET, api.NGB);
export const editshiftMapping = (data) =>
  serviceMaker(`/shiftmapping`, methods.PUT, api.NGB, data);
export const deleteShiftMapping = (id) =>
  serviceMaker(`/shiftmapping/${id}`, methods.DELETE, api.NGB);
export const getShiftMappingByTeamAndShift = (teamId, shiftId) =>
  serviceMaker(
    `/shiftmapping?teamId=${teamId}&shiftId=${shiftId}`,
    methods.GET,
    api.NGB
  );
